// © Microsoft Corporation. All rights reserved.

import { neutralFillStealthHover, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { enums } from "@msnews/social-utils";

export const PopupStyles = {
    overlayContainer: {
        display: "flex !important",
        "align-items": "center",
        "justify-content": "center",
        position: "fixed",
        left: "0px",
        right: "0px",
        top: "0px",
        bottom: "0px",
        "z-index": "9999999999",
        "background-color": "transparent",

        "& .cwt-overlay": {
            position: "absolute",
            left: "0px",
            right: "0px",
            top: "0px",
            bottom: "0px",
            "background-color": "rgba(0,0,0,0.5)"
        },

        "& .cwt-content": {
            position: "fixed",
            "z-index": "10",
            margin: "0",
            "max-width": "100%",
            "max-height": "calc(100% + 16px)",
            overflow: "auto",

            // 'Hide scrollbar'
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar ": {
                display: "none"
            },

            "& .cwt-corner-buttons": {
                position: "sticky",
                top: "40px",
                margin: "0 12px",
                "z-index": "9999",
                display: "flex",
                "font-size": "13px",
                "align-items": "center",
                "flex-direction": "row-reverse",

                "& .cwt-icon.cwt-link": {
                    padding: "8px",
                    color: neutralForegroundRest,
                    "border-radius": "4px",
                    background: neutralLayerCard,
                    "box-shadow": "0 0 3px rgb(0 0 0 / 10%)",

                    "&:hover": {
                        background: neutralFillStealthHover
                    }
                }
            },

            "& .cwt-content-container": {
                display: "block !important",
                overflow: "auto",
                height: "100%",
                "border-radius": "6px",

                "& > div": {
                    display: "block !important"
                }
            }
        },

        ["&."+enums.responsiveLevels.MobilePopup]: {
            "align-items": "flex-end",

            "& .cwt-content": {
                width: "100vw",

                "& .cwt-content-container": {
                    "border-radius": "20px 20px 0 0 !important"
                }

            }
        }
    }
};